import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import { Divider, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router";
import { Convert, FnAxios, FnDialog, I18n } from "utilities/utilities";
import { useEffect, useState, Fragment } from "react";
import { SelectItem } from "components/Input/Select/SelectItem";
import { FormProvider, useForm } from "react-hook-form";
import { DateRangePickerItem } from "components/Input/DatePicker/DateRangePickerItem";
import { MultipleSelectItem } from "components/Input/Select/MultipleSelectItem";
import { BtnClear, BtnExportExcel, BtnSearch } from "components/Button/ButtonAll";
import moment from "moment";
import { CheckBoxItem } from "components/Input/Checkbox/CheckBoxItem";



const ReportLeave = () => {
    const navigate = useNavigate();
    const onBack = () => navigate("/UserList");
    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const [lstDataLeave, setlstDataLeave] = useState([]);
    const [arrLeavetype, setarrLeavetype] = useState([]);
    const [arrYears, setarrYears] = useState([]);
    const [arrLeaveStatus, setarrLeaveStatus] = useState<any>([]);
    const [arrOrganization, setarrOrganization] = useState<any>([]);
    const [arrUser, setarrUser] = useState<any>([]);
    const [arrUserLogin, setarrUserLogin] = useState<any>([]);
    const [exportImg, setexportImg] = useState("");
    const [arrLeavetypeChk, setarrLeavetypeChk] = useState<dataLeave[]>([]);
    const [arrUserChk, setarrUserChk] = useState<dataLeave[]>([]);
    const [sStartDate, setStartDate] = useState("");
    const currentDate = new Date(); // Get the current date
    const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

    const form = useForm({
        shouldFocusError: true,
        shouldUnregister: false,
        mode: "all",

        defaultValues: {
            dRequestRange: [firstDayOfMonth, lastDayOfMonth],

        } as any,
    });

    const getFormInitial = () => {
        AxiosFn.Get(`ReportLeave/GetFormInitial`, {}, (result) => {
            (result.lstUser ?? []).forEach(f => {
                form.setValue(`chkUser_${f.value}`, f.value);

            });

            let lstCheckUser = [];
            result.lstUser.forEach((item) => {
                lstCheckUser.push({
                    value: item.value,
                    IsDelete: true,
                    label: item.label
                })
            })
            setarrUserChk([...lstCheckUser]);

            let lstCheckLeave = [];
            result.lstLeaveType.forEach((item) => {
                lstCheckLeave.push({
                    value: item.value,
                    IsDelete: true,
                    label: item.label
                })
            })
            setarrLeavetypeChk([...lstCheckLeave]);

            setarrLeavetype(result.lstLeaveType);
            setarrYears([...result.lstOptionYear]);
            setarrLeaveStatus(result.lstLeaveStatus);
            setarrOrganization(result.lstOrganization);
            setarrUser(result.lstUser);
            setarrUserLogin(result.lstUserLoginck);


            form.setValue("nUserID", result.lstSelectUser);
            form.setValue("nLeaveTypeID", result.lstSelectleaveType);
            form.setValue("nOrganization", result.lstselectPosition);
            // form.setValue("nYear",result.lstYear);
            (result.lstLeaveType ?? []).forEach(f => {
                form.setValue(`chk_${f.value}`, f.value);
            })

            getLeaveData();
        })
    }

    const onGetLeaveCheck = (nType, e, value) => {
        let lstDataType = []
        let lstCheckUser = [];
        if (nType == 1) {
            arrLeavetypeChk.forEach((item) => {
                lstDataType.push({
                    value: item.value,
                    IsDelete: value == item.value ? e : item.IsDelete,
                    label: item.label
                })
            })
            setarrLeavetypeChk([...lstDataType])
        } else {
            arrUserChk.forEach((item) => {
                lstCheckUser.push({
                    value: item.value,
                    IsDelete: value == item.value ? e : item.IsDelete,
                    label: item.label
                })
            })
            setarrUserChk([...lstCheckUser])
        }

        let dRequestStart = null;
        let dRequestEnd = null;
        if (
            form.getValues("dRequestRange") &&
            form.getValues("dRequestRange").length > 1
        ) {
            dRequestStart = Convert.DateTimeToString(
                form.getValues("dRequestRange")[0],
                "YYYY-MM-DD"
            );
            dRequestEnd = Convert.DateTimeToString(
                form.getValues("dRequestRange")[1],
                "YYYY-MM-DD"
            );
        }
        let param = {
            lstCkeckLeaveTypeID: lstDataType,
            lstCheckUserID: lstCheckUser,
            dRequestStart: dRequestStart,
            dRequestEnd: dRequestEnd,
        };
        AxiosFn.Post(`ReportLeave/GetFilterLeaveCkeck`, param, (result) => {
            DialogFn.UnBlockUI();
            setlstDataLeave(result.lstDataSummary || []);
        });
    }


    const getLeaveData = () => {
        let dRequestStart = null;
        let dRequestEnd = null;
        if (
            form.getValues("dRequestRange") &&
            form.getValues("dRequestRange").length > 1
        ) {
            dRequestStart = Convert.DateTimeToString(
                form.getValues("dRequestRange")[0],
                "YYYY-MM-DD"
            );
            dRequestEnd = Convert.DateTimeToString(
                form.getValues("dRequestRange")[1],
                "YYYY-MM-DD"
            );
        }

        let param = {
            lstYear: form.getValues("nYear"),
            dRequestStart: dRequestStart,
            dRequestEnd: dRequestEnd,
            lstLeaveTypeID: form.getValues("nLeaveTypeID"),
            lstStatusID: form.getValues("nStatusID"),
            lstUserID: form.getValues("nUserID"),
            lstnOrgID: form.getValues("nOrganization"),
            sExportImg: exportImg
        };

        DialogFn.BlockUI();
        AxiosFn.Post(`ReportLeave/GetDateLeave`, param, (result) => {
            DialogFn.UnBlockUI();
            setlstDataLeave(result.lstDataSummary || []);

        }, (err) => {
            DialogFn.UnBlockUI();
            if (!err.response) {
                DialogFn.Warning(err.sMessage);
            }
        });
    };

    useEffect(() => {
        setStartDate((moment) + "");
        getFormInitial();
        getLeaveData();
    }, []);

    useEffect(() => {
        Graph1();
    }, [lstDataLeave])

    useEffect(() => {
        var dateobj = new Date();
        var currentYear = dateobj.getFullYear();
        form.setValue("nYear", [currentYear + 543])
    }, []);


    const Graph1 = () => {
        am4core.addLicense("CH208466903"); //รหัสรายเส้นใช้ไม่ให้ขึ้นเส้นโลโก้

        var chart = am4core.create("chartdiv", am4charts.XYChart3D);
        const arrData = lstDataLeave.map((item) => {
            let resultData = {
                category: item.sUserName,
            };
            (item.lstLeaveDetail ?? []).forEach(detail => {
                resultData[`value_${detail.nLeaveTypeID}`] = detail.nLeaveTypeID == 2 ? detail.nLeaveAbsence > 0 ? detail.nLeaveAbsence : null : detail.nLeaveSick > 0 ? detail.nLeaveSick : null
            })
            return resultData;
        });

        chart.data = arrData
        chart.colors.step = 2;
        chart.padding(30, 30, 10, 30);
        chart.legend = new am4charts.Legend();
        chart.colors.list = [
            am4core.color("#4472c5"),
            am4core.color("#FF6600"),
        ];
        // Create axes
        var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "category";
        categoryAxis.renderer.grid.template.location = 0;


        var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.min = 0;
        valueAxis.max = 50;
        valueAxis.strictMinMax = true;
        valueAxis.calculateTotals = true;

        // Create series
        arrLeavetype.map((item) => {
            var series = chart.series.push(new am4charts.ColumnSeries3D());
            series.columns.template.tooltipText = "{name}: {valueY}";
            series.dataFields.valueY = "value_" + item.value;
            series.dataFields.categoryX = "category";
            series.name = item.label;
            series.tooltipText = "{name}: {valueY}";
            series.stacked = true;
            series.columns.template.width = 60;
            series.tooltip.pointerOrientation = "vertical";


            var bullet1 = series.bullets.push(new am4charts.LabelBullet());
            bullet1.label.text = "{valueY}";
            bullet1.label.fill = am4core.color("#ffffff");
            bullet1.locationY = 0.5;
        })

        chart.exporting.getImage("png").then((data) => {
            if (data != "" && data != "data:,") {
                setexportImg(data);
            }
        });
    }


    const onClearData = () => {
        form.setValue("nUserID", []);
        form.setValue("dRequestRange", [null, null]);
        form.setValue("nLeaveTypeID", []);
        form.setValue("nStatusID", []);
        form.setValue("nOrganization", []);
        form.setValue("nYear", []);
        getLeaveData();
    };
    const handleExportExcel = () => {

        let dRequestStart = null;
        let dRequestEnd = null;
        if (
            form.getValues("dRequestRange") &&
            form.getValues("dRequestRange").length > 1
        ) {
            dRequestStart = Convert.DateTimeToString(
                form.getValues("dRequestRange")[0],
                "YYYY-MM-DD"
            );
            dRequestEnd = Convert.DateTimeToString(
                form.getValues("dRequestRange")[1],
                "YYYY-MM-DD"
            );
        }
        let sFileName = `รายงานสรุปการลา.xlsx`
        let param = {
            lstYear: form.getValues("nYear"),
            dRequestStart: dRequestStart,
            dRequestEnd: dRequestEnd,
            lstLeaveTypeID: form.getValues("nLeaveTypeID"),
            lstStatusID: form.getValues("nStatusID"),
            lstUserID: form.getValues("nUserID"),
            lstnOrgID: form.getValues("nOrganization"),
            sExportImg: exportImg
        };
        AxiosFn.DowloadFileBlob(`ReportLeave/OnExportExcel`, param, sFileName, (result) => {
            DialogFn.UnBlockUI();
        });
    }
    return (
        <Fragment>
            <FormProvider {...form}>
                <Grid container justifyContent={"end"} spacing={2}>
                    <Grid item xs={12} md={2}>
                        <MultipleSelectItem
                            name={'nYear'}
                            label={"ปี"}
                            options={arrYears || []}
                            id='nYear'
                            required={false}
                            placeholder={'ปี'}
                        />
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <MultipleSelectItem
                            id={'nLeaveTypeID'}
                            name={'nLeaveTypeID'}
                            label={"ประเภทการลา"}
                            placeholder={'เลือกประเภทารลา'}
                            options={arrLeavetype || []}
                            required={false}
                        />
                    </Grid>
                    <Grid item md={7} xs={12}>
                        <DateRangePickerItem
                            label={"Date Range"}
                            labelStart={"ตั้งแต่วันที่"}
                            labelEnd={"ถึงวันที่"}
                            id={"inpDate"}
                            name={"dRequestRange"}
                            required={false}
                        />
                    </Grid>

                    <Grid item md={3} xs={12}>
                        <MultipleSelectItem
                            id={'nStatusID'}
                            name={'nStatusID'}
                            label={"สถานะ"}
                            placeholder={'เลือกสถานะ'}
                            options={arrLeaveStatus || []}
                            required={false}
                        />
                    </Grid>
                    <Grid item md={4.5} xs={12}>
                        <MultipleSelectItem
                            id={'nUserID'}
                            name={'nUserID'}
                            label={"ผู้ใช้งาน"}
                            placeholder={'เลือกผู้ใช้งาน'}
                            options={arrUser || []}
                            required={false}
                            limitTag={1}
                        />
                    </Grid>
                    <Grid item md={4.5} xs={12}>
                        <MultipleSelectItem
                            id={'nOrganization'}
                            name={'nOrganization'}
                            label={"หน่วยงานสังกัด"}
                            placeholder={'เลือกหน่วยงานสังกัด'}
                            options={arrOrganization || []}
                            required={false}
                            limitTag={1}
                        />
                    </Grid>
                    <Grid item flex={1} container gap={2} justifyContent="flex-end">
                        <BtnExportExcel id={"ExportExcel"} txt="Excel" tooltiptxt={I18n.SetText("ReportLeave.ExportExcel")} onClick={() => { handleExportExcel() }} />
                        <BtnSearch id="search" onClick={form.handleSubmit(() => getLeaveData(), (err) => console.log("err", err))} />
                        <BtnClear id="ClearID" onClick={() => onClearData()} />
                    </Grid>
                </Grid>

                <Grid container justifyContent="center" sx={{ mt: 5 }}>
                    <Grid item xs={12} md={12}>
                        <div id="chartdiv" style={{ width: "100%", height: "450px" }}></div>
                    </Grid>

                    {/* <Grid item xs={3} md={3} justifyContent="flex-end">
                        <Grid
                            container
                            direction="row"
                        >
                            {arrLeavetype != null && arrLeavetype.length > 0 ? arrLeavetype.map((item, index) => (
                                <Grid item xs={12} md={6} key={index} sx={{ mt: 1 }}>
                                    <CheckBoxItem
                                        name={"chk_" + item.value}
                                        label={""}
                                        options={arrLeavetype.filter(f => f.value === item.value)}
                                        onChange={(e) => {
                                            onGetLeaveCheck(1, e, item.value)
                                        }}
                                        disabled={false}
                                        id={"chk_" + item.value}
                                        required={false}
                                    />
                                </Grid>

                            )) : <></>}
                        </Grid>

                        {arrUser != null && arrUser.length > 0 ? arrUser.map((item, index) => (
                            <>
                                <Grid item xs={12} md={12} key={index} sx={{ mt: 1 }}>
                                    <CheckBoxItem
                                        name={"chkUser_" + item.value}
                                        label={""}
                                        options={arrUser.filter(f => f.value === item.value)}
                                        onChange={(e) => {
                                            onGetLeaveCheck(2, e, item.value)
                                        }}
                                        disabled={false}
                                        id={"chkUser_" + item.value}
                                        required={false}
                                    />

                                </Grid>
                            </>)) : <></>}
                    </Grid> */}

                </Grid>
            </FormProvider>
        </Fragment >
    )
}
export default ReportLeave;
export interface dataLeave {
    IsDelete: boolean
    value: number
    label: String
}